export default function setErrorRes(error) {
  const res = {
    status: error?.response?.status,
    message: error?.response?.data?.message,
  };

  return res;
}
